import React, { useState, useEffect, PropTypes } from "react"
import SearchListBox from "./SearchBox";
import { Col, Container, Row, Form, Button } from 'react-bootstrap';
import { navigate } from "@reach/router"
import Select from 'react-select';
import $ from "jquery";
import _ from "lodash"



const styles = {
  control: styles => ({ ...styles, backgroundColor: '#f7fbff', border: 0, outline: 0, boxShadow: 'none', fontSize: '14px', color: '#263140', minHeight: '3rem', paddingLeft: '1rem', marginBottom: '1rem' }),
  placeholder: (defaultStyles) => {
    return {
      ...defaultStyles,
      color: '#263140',
    }
  }
}

const SearchFilter = (props) => {
  const [filterOpen, setFilterOpen] = useState(false);
  const [areaVal, setAreaVal] = useState('');
  const [minpriceVal, setMinPriceVal] = useState('');
  const [maxpriceVal, setMaxPriceVal] = useState('');
  const [propertyval, setPropertyVal] = useState('');
  const [bedVal, setBedVal] = useState('');
  const [minPriceList, setMinPriceList] = useState([]);
  const [maxPriceList, setMaxPriceList] = useState([]);
  var area = "";
  const options = [
    { value: "", label: "Any" },
    { value: '1', label: '1 +' },
    { value: '2', label: '2 +' },
    { value: '3', label: '3 +' },
    { value: '4', label: '4 +' },
    { value: '5', label: '5 +' }
  ]
  const propertytypelist = [
    { value: "", label: "All" },
    { value: "house", label: "Houses" },
    { value: "apartment", label: "Apartments" },
    { value: "bungalow", label: "Bungalows" },
    { value: "maisonette", label: "Maisonettes" },
    { value: "land", label: "Lands" },
    { value: "leasehold-interest", label: "Leasehold Interests" },
    { value: "auction", label: "Auctions" },
    { value: "private-treaty", label: "Private Treaty" },
    { value: "shared-ownership", label: "Shared Ownership" },
    // { value: "semi-detached-house", label: "Semi Detached House" }
  ]
  // Min Price
  const [selectedMinPriceValue, setSelectedMinPriceValue] = useState(0);
  const priceminRange = [{ "value": "0", "label": "No Min" }, { "value": "25000", "label": "£25,000" }, { "value": "50000", "label": "£50,000" }, { "value": "75000", "label": "£75,000" }, { "value": "100000", "label": "£100,000" }, { "value": "125000", "label": "£125,000" }, { "value": "150000", "label": "£150,000" }, { "value": "175000", "label": "£175,000" }, { "value": "200000", "label": "£200,000" }, { "value": "225000", "label": "£225,000" }, { "value": "250000", "label": "£250,000" }, { "value": "275000", "label": "£275,000" }, { "value": "300000", "label": "£300,000" }, { "value": "350000", "label": "£350,000" }, { "value": "400000", "label": "£400,000 +" }]
  const priceminRangeLettings = [{ "value": "0", "label": "No Min" }, { "value": "350", "label": "£350 PCM" }, { "value": "400", "label": "£400 PCM" }, { "value": "450", "label": "£450 PCM" }, { "value": "500", "label": "£500 PCM" }, { "value": "550", "label": "£550 PCM" }, { "value": "600", "label": "£600 PCM" }, { "value": "700", "label": "£700 PCM" }, { "value": "800", "label": "£800 PCM" }, { "value": "900", "label": "£900 PCM" }, { "value": "1000", "label": "£1000 PCM" }, { "value": "1250", "label": "£1250 PCM" }, { "value": "1500", "label": "£1500 PCM" }, { "value": "1750", "label": "£1750 PCM" }, { "value": "2000", "label": "£2000 PCM" }]
  const [selectedMaxPriceValue, setSelectedMaxPriceValue] = useState(0);
  const pricemaxRangeLettings = [{ "value": "0", "label": "No Max" }, { "value": "2000", "label": "£2000 PCM" }, { "value": "1750", "label": "£1750 PCM" }, { "value": "1500", "label": "£1500 PCM" }, { "value": "1250", "label": "£1250 PCM" }, { "value": "1000", "label": "£1000 PCM" }, { "value": "900", "label": "£900 PCM" }, { "value": "800", "label": "£800 PCM" }, { "value": "700", "label": "£700 PCM" }, { "value": "600", "label": "£600 PCM" }, { "value": "550", "label": "£550 PCM" }, { "value": "500", "label": "£500 PCM" }, { "value": "450", "label": "£450 PCM" }, { "value": "400", "label": "£400 PCM" }, { "value": "350", "label": "£350 PCM" }]
  const pricemaxRange = [
    { value: "0", label: "No Max" },
    { value: "1000000", label: "£ 1,000,000" },
    { value: "900000", label: "£ 900,000" },
    { value: "800000", label: "£ 800,000" },
    { value: "700000", label: "£ 700,000" },
    { value: "600000", label: "£ 600,000" },
    { value: "500000", label: "£ 500,000" },
    { value: "400000", label: "£ 400,000" },
    { value: "350000", label: "£ 350,000" },
    { value: "300000", label: "£ 300,000" },
    { value: "275000", label: "£ 275,000" },
    { value: "250000", label: "£ 250,000" },
    { value: "225000", label: "£ 225,000" },
    { value: "200000", label: "£ 200,000" },
    { value: "175000", label: "£ 175,000" },
    { value: "150000", label: "£ 150,000" },
    { value: "125000", label: "£ 125,000" },
    { value: "100000", label: "£ 100,000" },
    { value: "75000", label: "£ 75,000" },
    { value: "50000", label: "£ 50,000" }
  ]
  if (!_.isEmpty(props.searchState)) {
    //console.log('lllll', props.searchState, areaVal)
    if (!_.isEmpty(props.searchState?.query) && props.searchState?.query !== areaVal) {
      
      setAreaVal(props.searchState?.query) 
    }
  }
  useEffect(() => {
    if (_.isEmpty(minPriceList)) {
      if (props.type === "lettings") {
        setMinPriceList(priceminRangeLettings);
        setMaxPriceList(pricemaxRangeLettings);
      } else {
        setMinPriceList(priceminRange)
        setMaxPriceList(pricemaxRange)
      }
    }


    // setAreaVal(_.upperFirst(pathUri[vi].replace("in-", "").replace(/-/g, " ")))

    const url = typeof window !== 'undefined' ? window.location.href : ''
    let pathUri = url.split("/")
    for (let vi = 1; vi <= pathUri.length; vi++) {
      // check for area
      if (typeof pathUri[vi] === "undefined") {
        continue
      }

      // Property type
      if (pathUri[vi].indexOf("type-") >= 0) {
        setPropertyVal(pathUri[vi].replace("type-", ""))
      }
      // Property type

      // Area
      if ((pathUri[vi].indexOf("in-") == 0) && (pathUri[vi].indexOf("in-london") == -1)) {
        setAreaVal(_.upperFirst(pathUri[vi].replace("in-", "").replace(/-/g, " ")))
      }
      // Area

      // Price
      if (
        pathUri[vi].indexOf("between-") >= 0 ||
        pathUri[vi].indexOf("above-") >= 0 ||
        pathUri[vi].indexOf("below-") >= 0
      ) {
        let priceFilt1 = pathUri[vi].split("above-")
        if (priceFilt1[1]) {
          setMinPriceVal(priceFilt1[1])
        }
        let priceFilt2 = pathUri[vi].split("below-")
        if (priceFilt2[1]) {
          setMaxPriceVal(priceFilt2[1])
        }
        let priceFilt3 = pathUri[vi].split("between-")
        if (priceFilt3[1]) {
          let priceFilt4 = priceFilt3[1].split("-and-")
          setMinPriceVal(priceFilt4[0])
          setMaxPriceVal(priceFilt4[1])
        }
      }
      // Price

      // Bedrooms
      if (pathUri[vi].indexOf("-and-more-") >= 0) {
        setBedVal(pathUri[vi].replace("-and-more-bedrooms", ""))
      }
      // Bedrooms 

    }
  }, []);


  const submitSearch = (e) => {
    e.preventDefault();
    var areaValue = $(".searchboxresults .searchVal").val().split(', ').join('-').replace(/ /g, "-").replace(/'/g, "").toLowerCase();
    if (_.isEmpty(areaValue)) {
      areaValue = $(".mobsearchboxresults .searchVal").val().split(', ').join('-').replace(/ /g, "-").replace(/'/g, "").toLowerCase();
    }
    var bedroomValue = bedVal ? bedVal : $(".bedroom-input input[type='hidden']").val();
    var buildingValue = propertyval ? propertyval : $(".building-dropdown input[type='hidden']").val();
    let priceUrl = ""
    if (maxpriceVal || minpriceVal) {
      if (minpriceVal && maxpriceVal && minpriceVal != "0" && maxpriceVal != "0") {
        priceUrl = "between-" + minpriceVal + "-and-" + maxpriceVal
      } else
        if ((minpriceVal == '' || minpriceVal == "0") && maxpriceVal && maxpriceVal != "0") {
          priceUrl = "below-" + maxpriceVal
        }
        else if (minpriceVal && (maxpriceVal == '' || maxpriceVal == "0") && minpriceVal != "0") {
          priceUrl = "above-" + minpriceVal
        }

    }
    var baseTypeUrl = (areaValue ? "/property/for-sale/in-" + areaValue + "/" : "/property/for-sale/");
    if (props.type == "lettings") {
      baseTypeUrl = (areaValue ? "/property/to-rent/in-" + areaValue + "/" : "/property/to-rent/");
    }
    var searchFilterResults = (
      baseTypeUrl +
      (buildingValue ? "type-" + buildingValue + "/" : '') +
      (bedroomValue && bedroomValue != "0" ? bedroomValue + "-and-more-bedrooms/" : '') +
      (priceUrl ? priceUrl + "/" : '')

    );

    navigate(searchFilterResults)
  }
  // Min price
  const onChangeMinPrice = (e) => {
    setSelectedMinPriceValue(e.value);
    if (props.type === "lettings") {
      var maxPrice = pricemaxRangeLettings.filter(c => (c.value === "0" || parseInt(c.value) > parseInt(e.value)));
      setMaxPriceList(maxPrice);
    } else {
      var maxPrice = pricemaxRange.filter(c => (c.value === "0" || parseInt(c.value) > parseInt(e.value)));
      setMaxPriceList(maxPrice);
    }
  }
  // Min price

  // Max Price
  const onChangeMaxPrice = (e) => {
    setSelectedMaxPriceValue(e.value);
    if (props.type === "lettings") {
      var minPrice = priceminRangeLettings.filter(c => (c.value === "0" || parseInt(c.value) < parseInt(e.value)));
      setMinPriceList(minPrice);
    } else {
      var minPrice = priceminRange.filter(c => (c.value === "0" || parseInt(c.value) < parseInt(e.value)));
      setMinPriceList(minPrice);
    }
  }
  // Max Price

  // Filters
  const fitlerDisplay = (e) => {
    $(".dropdown-exp").toggleClass("active");
  }
  // Filters

  return (
    <React.Fragment>
      <section className="filter ">
        <div className="filter-field">
          <Container>
            <Row>
              <Col className="filter-fixed ">
                <Form className="form-data" onSubmit={(e) => { submitSearch(e) }}>
                  <div className="search-box searchboxresults d-none d-lg-block">
                    <SearchListBox areaVal={areaVal} />
                    <i className="icon-search">
                    </i>
                  </div>

                  <div className={filterOpen ? "filter-mobile_btn d-lg-none filter-up" : "filter-mobile_btn d-lg-none"} onClick={() => { setFilterOpen(!filterOpen) }}>
                    <span>Filter</span>
                    <i className="icon-down"></i>
                  </div>
                  <div className={filterOpen ? "box-wrapper d-xl-flex d-block" : "box-wrapper d-xl-flex"}>
                    <div className="search-box mobsearchboxresults d-lg-none">
                      <SearchListBox areaVal={areaVal} />
                      <i className="icon-search">
                      </i>
                    </div>
                    <div className="select-boxes select-boxes-buy">
                      <Select
                        name="beds"
                        options={options}
                        value={{ label: bedVal ? options.find(obj => obj.value === bedVal).label : "Beds", value: bedVal ? bedVal : "" }}
                        placeholder="Beds"
                        classNamePrefix={"bedroom-input select-opt"}
                        styles={styles}
                        onChange={e => setBedVal(e.value)}
                        isSearchable={false}
                      />
                    </div>
                    <div className="select-boxes price-list">
                      <Select
                        name="minprice"
                        options={minPriceList}
                        value={minPriceList.find(obj => obj.value === minpriceVal)}
                        isSearchable={false}
                        placeholder="Min Price"
                        classNamePrefix={"select-opt"}
                        onChange={e => { onChangeMinPrice(e); setMinPriceVal(e.value) }}
                        styles={styles}
                      />
                    </div>
                    <div className="select-boxes price-list">
                      <Select
                        name="maxprice"
                        options={maxPriceList}
                        value={maxPriceList.find(obj => obj.value === maxpriceVal)}
                        isSearchable={false}
                        placeholder="Max Price"
                        classNamePrefix={"select-opt"}
                        onChange={e => { onChangeMaxPrice(e); setMaxPriceVal(e.value) }}
                        styles={styles}

                      />
                    </div>
                    <div className="select-boxes type-list">
                      <Select
                        name="building"
                        options={propertytypelist}
                        defaultValue={{ value: 0, label: "All" }}
                        value={propertytypelist.find(obj => obj.value === propertyval)}
                        placeholder="Property Type"
                        classNamePrefix={"select-opt"}
                        onChange={e => setPropertyVal(e.value)}
                        isSearchable={false}
                        styles={styles}

                      />
                    </div>
                    <div className="select-boxes button">
                      <button type="submit" class="btn btn-primary btn btn-primary search-button">Submit</button>

                    </div>
                  </div>

                </Form>
              </Col>
            </Row>
          </Container>
        </div>
      </section>
    </React.Fragment >
  );
};

export default SearchFilter;
